import { render } from "./tpl-tab.vue?vue&type=template&id=3a634ecc&scoped=true"
import script from "./tpl-tab.vue?vue&type=script&lang=js"
export * from "./tpl-tab.vue?vue&type=script&lang=js"

import "./tpl-tab.vue?vue&type=style&index=0&id=3a634ecc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a634ecc"],['__file',"src/views/dragger/template/tpl-tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a634ecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a634ecc', __exports__)) {
    console.log('reload')
    api.reload('3a634ecc', __exports__)
  }
  
  module.hot.accept("./tpl-tab.vue?vue&type=template&id=3a634ecc&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a634ecc', render)
  })

}


export default __exports__